import * as React from 'react';

export const loaderRef = React.createRef() as any;

const setLoader = (value: boolean) => {
    loaderRef?.current?.setLoader(value);
};

export default setLoader;